import { put, takeLatest } from 'redux-saga/effects';

import { sagaErrorDispatcher, sagaCallService } from 'Helpers';
import notificationTypes from './types';
import notificationActions from './actions';
import notificationServices from './services';

function* fetchNotificationsRequest(action) {
	try {
		let response = yield sagaCallService(
			notificationServices.fetch,
			action,
			action.payload
		);
		yield put(notificationActions.fetchNotificationsSuccess(response.data));
	} catch (e) {
		// yield sagaErrorDispatcher(
		// 	e,
		// 	action,
		// 	notificationActions.fetchNotificationsFailure
		// );
	}
}

function* updateNotificationsRequest(action) {
	try {
		let response = yield sagaCallService(
			notificationServices.update,
			action,
			action.payload
		);
		yield put(notificationActions.updateNotificationsSuccess(response.data));
	} catch (e) {
		// yield sagaErrorDispatcher(
		// 	e,
		// 	action,
		// 	notificationActions.updateNotificationsFailure
		// );
	}
}

const notificationSagas = [
	takeLatest(notificationTypes.FETCH.REQUEST, fetchNotificationsRequest),
	takeLatest(notificationTypes.UPDATE.REQUEST, updateNotificationsRequest),
];

export default notificationSagas;
